import { FC } from 'react';
import cx from 'classnames/bind';

import { Layout } from '@/components/Layout';
import { Button } from '@/components/Button';

import styles from './Completion.module.scss';

interface CompletionProps {
  src: string;
  title: string;
  description: string;
  buttonText: string;
  handleClick: () => void;
}

const cn = cx.bind(styles);

const Completion: FC<CompletionProps> = ({
  src,
  title,
  description,
  buttonText,
  handleClick,
}) => (
  <Layout className={cn('container')}>
    <div className={cn('wrapper')}>
      <div className={cn('imgWrapper')}>
        <img
          src={src}
          className={cn('img')}
          alt="Диалог между клиентом и сотрудником"
        />
      </div>
      <div className={cn('content')}>
        <h1 className={cn('title')}>{title}</h1>
        <p className={cn('description')}>{description}</p>
        <Button handleClick={handleClick}>{buttonText}</Button>
      </div>
    </div>
  </Layout>
);
export default Completion;
